export default __webpack_public_path__ + "static/media/image3.b816fa68.jpg";